import { decodeCvFormValues } from '@/models/CV/CvFormValues';
import { ServerApi } from '@/modules/api/server-api';

export const fetchCandidateCv = (api: ServerApi) => async () => {
  const response = await api.get('/candidate/resume');
  return decodeCvFormValues(response.data);
};
